const styles = ({ login, spacing: { unit }, typography: { fontWeightHeavy } }) => ({
  loginForm: {
    padding: `${unit * 2}px 0`,
    ...(login.form.backgroundColor
      ? {
          backgroundColor: login.form.backgroundColor
        }
      : []),
    '& fieldset': {
      margin: 0
    }
  },

  buttonLink: {
    '$loginForm &.btn': {
      paddingLeft: 0
    }
  },

  formLabel: {
    width: '100%'
  },

  successAlert: {
    wordBreak: 'break-word',
    minWidth: 'unset'
  },

  rememberIdSwitch: {
    '& span': {
      fontWeight: fontWeightHeavy
    }
  }
});

export default styles;
